import React from 'react';
import MuiDeleteForEverIcon from '@material-ui/icons/DeleteForever';
import { DefaultComponentProps } from '@material-ui/core/OverridableComponent';

export const DeleteForEverIcon = (props: DefaultComponentProps<any>) => (
  <MuiDeleteForEverIcon {...props} />
);
